<template>
	<div>
		<md-content>

		    

		    
		    <div class="md-layout md-gutter"> 
		    	<h2 class="md-layout-item md-xsmall-size-100">屏蔽策略</h2>
		    	 <div class="md-layout md-gutter">
					<div class="md-layout-item md-xsmall-size-25">
						<md-button class="md-raised"  @click.native="goback">返回</md-button>
					</div>
					<div class="md-layout-item md-xsmall-size-25">
						<md-button class="md-raised md-primary"  @click.native="addProduct">新增</md-button>
					</div>
					<!--<div class="md-layout-item md-xsmall-size-25">
						<md-button class="md-raised md-primary"  @click="changeStatus(false,1)">启用</md-button>
					</div>-->
					<div class="md-layout-item md-xsmall-size-25">
						<md-button class="md-raised md-accent"  @click="deleteProduce(false,-1)">删除</md-button>
					</div>
		
	    		</div>
	    		<div class="md-layout-item md-xsmall-size-100">
			     	<md-table v-model="plist" v-if="plist.length>0"  @md-selected="onSelect"> 
						
				     	<md-table-row  slot="md-table-row" slot-scope="{ item }"  md-selectable="multiple" md-auto-select>
					        <md-table-cell md-label="ID"  md-numeric>{{ item.id }}</md-table-cell>
					        <md-table-cell md-label="渠道名称" >{{ item.channel }}</md-table-cell>
					        <md-table-cell md-label="扣量比例" >{{item.pr}}</md-table-cell>
					        <md-table-cell md-label="扣量mieia_id" >{{item.media_o}}</md-table-cell>
					        <md-table-cell md-label="扣量link_id">{{item.link_o}}</md-table-cell>
					        <md-table-cell md-label="原始mieia_id" >{{item.media}}</md-table-cell>
					        <md-table-cell md-label="原始link_id">{{item.link}}</md-table-cell>
					        
					        
					        <md-table-cell md-label="操作" ><md-button size="medium" type="primary" @click="editRule(item)">编辑</md-button></md-table-cell>
					        
					    </md-table-row>
			     	</md-table>
						    
				    <md-table  v-else>
				      <md-table-row>
				        <md-table-head>暂无信息</md-table-head>
				      </md-table-row>
					</md-table>
			    </div> 
		    </div> 
		    
		    
		   
		   <md-dialog class="editDialog" :md-active.sync="editDialog">
			
		  <form novalidate  @submit.prevent="validateUser">
		  <md-content style="padding: 10px;">
	      <md-dialog-title>{{isAdd==true?"新增扣量策略":"编辑扣量策略"}}</md-dialog-title>
	     
		  <div class="md-layout md-gutter md-alignment-center">
		  	
		  	<div class="md-layout-item md-medium-size-100 md-small-size-100 md-xsmall-size-100">
		  		 <div class="md-layout-item md-xsmall-size-100">
			      	<md-field :class="getValidationClass('channel')">
				      <label>渠道名称</label>
				      <md-input v-model="rule.channel"  placeholder="渠道名称"  @input="inputCG()"></md-input>
				      <span class="md-error">请输入渠道名称</span>
				    </md-field>
		        </div>
		       <div class="md-layout-item md-xsmall-size-100">
			      	<md-field>
				      <label>扣量比例</label>
				      <md-input v-model="rule.pr"  placeholder="扣量比例"  @input="inputCG()"></md-input>
				    </md-field>
		        </div>
		        <div class="md-layout-item md-xsmall-size-100">
			      	<md-field>
				      <label>扣量mieia_id</label>
				      <md-input v-model="rule.media_o"  placeholder="扣量mieia_id"  @input="inputCG()"></md-input>
				    </md-field>
		        </div>
		        <div class="md-layout-item md-xsmall-size-100">
			      	<md-field>
				      <label>扣量link_id</label>
				      <md-input v-model="rule.link_o"  placeholder="扣量link_id"  @input="inputCG()"></md-input>
				    </md-field>
		        </div>
		        <div class="md-layout-item md-xsmall-size-100">
			      	<md-field>
				      <label>原始mieia_id</label>
				      <md-input v-model="rule.media"  placeholder="原始mieia_id"  @input="inputCG()"></md-input>
				    </md-field>
		        </div>
		        <div class="md-layout-item md-xsmall-size-100">
			      	<md-field>
				      <label>原始link_id</label>
				      <md-input v-model="rule.link"  placeholder="原始link_id"  @input="inputCG()"></md-input>
				    </md-field>
		        </div>
			</div>
		  </div>
		  
		  <md-progress-bar md-mode="indeterminate" v-if="sending" />
	      <md-dialog-actions>
	        <md-button class="md-primary" @click="editDialog = false">取消</md-button>
	        <md-button type="submit" class="md-primary" :disabled="sending">保存</md-button>
	        <!--<md-button class="md-primary" type="submit" :disabled="sending">保存</md-button>-->
	      </md-dialog-actions>
	       </md-content>
	       </form>
	    </md-dialog>
		    
		   <md-dialog-alert
	      :md-active.sync="isSuc"
	      :md-content="successMessage"
	      md-confirm-text="知道了!" />
	      
	      <md-dialog-alert
	      :md-active.sync="isErr"
	      :md-content="ErrorMessage"
	      md-confirm-text="知道了!" />  
		    
		</md-content>
	</div>
</template>

<script>
	import parse from 'date-fns/parse'
  	import format from 'date-fns/format'
  	import isValid from 'date-fns/isValid'
	import {rulesAldDetailList ,aldbatchAdd ,rulesAldEdit,aldbatchDelete } from "../api/api";
	import { required, minLength, between } from 'vuelidate/lib/validators';
	export default {
		 data() {
		 	let dateFormat = this.$material.locale.dateFormat || 'yyyy-MM-dd'
      		let now = new Date();
      		let history = new Date(new Date().getTime() - 3600 * 1000 * 24*30);
		 	return{
		 		 pdata: {
			      	index_id:'',
			      	kw:'',
			      },
			     plist:[],
			     chooseProduct:{name:"",issued_app_id:''},
			     selected:[],
			     cP: {
			        channels: [],
			      }, //修改选中的产品状态,批量修改状态
			     rule:{
					"channel":"",
					"pr": "",
				    "media_o": "",
				    "link_o": "",
				    "media": "",
				    "link": ""
				},
				applist:[],
				editDialog:false,
				sending:false,
				isAdd:false,
				isSuc:false,
			    isErr:false,
			    successMessage:'',
			    ErrorMessage:'',
			 	}
		 	  
		 },
		  validations: {
	     	rule:{
	     		channel:{
		          required,
		        }
	     	}
	      },
		   watch: {
		  },
		 methods:{
		 	goback(){
		  		this.$router.back(-1)
		  	},
		 	inputCG(){
  		
		  		this.$forceUpdate();
		  	},
		 	getValidationClass (fieldName) {
		 	
		        const field = this.$v.rule[fieldName]
		
		        if (field) {
		          return {
		            'md-invalid': field.$invalid && field.$dirty
		          }
		        }
		      },
		 	onSelect (items) {
		 		
		        this.selected = items;
		        var arr=[];
		        this.selected.forEach((v,i)=>{
		        	arr.push(v.channel)
		        	
		        })
		        this.cP.channels=arr;
		    },
		     addProduct() {
		    	this.rule={
	  				"channel":"",
					"pr": "",
				    "media_o": "",
				    "link_o": "",
				    "media": "",
				    "link": ""
				};
		        this.editDialog = true;
		        this.isAdd = true;
		    },
		    editRule(d) {
		      this.editDialog = true;
		      this.rule = d;
		      this.isAdd = false;
		    },
		 	getList() {
			      var p = "";
			      this.cyPdata=this.pdata;
			      this.cyPdata.kw=this.pdata.issued_app_name;
			      for (var k in this.cyPdata) {
			        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
			        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
			      }

			     rulesAldDetailList(p, this.$cookie.getCookie("login")).then(res => {
			        if (res.code == 200) {
			//      	res.data.rule.forEach((v,i)=>{
			//      		v.keyid=i
			//      		
			//      	})
					  this.chooseProduct.issued_app_id =  res.data.issued_app_id;
			          if(res.data.rule&&res.data.rule.length>0){
			          	  this.plist = res.data.rule;
			          }
			         
			
			          //统计扣量渠道个数
			          this.prChannelTotalNum=this.plist.length || 0;
			          this.prChannelNum=0;
			          for(let item of this.plist){
			            if(parseFloat(item.pr)!=1){
			                this.prChannelNum++;
			            }
			          }
			          
			        }
			      });
			},
			submit() {
			      var rule=[];
			      rule.push(this.rule);
			
			//    this.$refs.ruleForm.validate(valid => {
			//      if (valid) {
			          if (this.isAdd) {
			          	var p ={
			          		"index_id":this.pdata.index_id,
			     					"rule":encodeURIComponent(JSON.stringify(rule))
			          	};
			            aldbatchAdd(p, this.$cookie.getCookie("login")).then(
			              res => {
			                if (res.code == 200) {
			                	
			                  this.getList();
			                  this.editDialog = false;
			                  this.isSuc=true;
		          			  this.successMessage='成功';
			                } else {
				                this.isErr=true;			     
					    		this.ErrorMessage=res.msg
			                	
			                 
			                }
			              }
			            );
			          } else {
			//          this.$prompt("请输入编辑原因", "提示", {
			//            confirmButtonText: "确定",
			//            cancelButtonText: "取消",
			//            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
			//            inputErrorMessage: "内容不能为空"
			//          }).then(({ value }) => {
			              //this.chooseProduct.log = value;
			              	var p ={
					          	  "index_id":this.pdata.index_id,
					         			"rule":this.rule,
					          	}
			              rulesAldEdit(p, this.$cookie.getCookie("login")).then(
			                res => {
			                  if (res.code == 200) {
			                    this.getList();
			                    this.isSuc=true;
		          			    this.successMessage='成功';
			                    this.editDialog = false;
			                  } else {
			                    this.isErr=true;			     
					    		this.ErrorMessage=res.msg
			                  }
			                }
			              );
			//          });
			          }
			//      } else {
			//        return false;
			//      }
			//    });
			    },
			
			
			 getConfig() {
		      if (this.$store.config) {
		        this.config = this.$store.config.product_theme;
		        this.tags = this.$store.config.product_tag;
		        this.option = this.$store.config.product_placement;
		      } else {
		        setTimeout(() => {
		          this.getConfig();
		        }, 50);
		      }
		    },
		    clearPlacement(s){
		    	this.pdata.placement = '';
		    },
		    validateUser () {

		        this.$v.$touch()
				
		        if (!this.$v.$invalid) {
		          console.log('保存');
		          this.submit();
		        }
		    },
		    deleteProduce(isSingle,s){
		     	if(this.selected.length>0){
		     		var p={
						"index_id":this.pdata.index_id,
						"channels": this.cP.channels
					}
			    	aldbatchDelete(p, this.$cookie.getCookie("login")).then(res => {
				        	if (res.code == 200) { 
					          this.isSuc=true;
		          			  this.successMessage='成功';
			                  this.editDialog = false;
					          this.getList();
						      }
				        	else{
				        		this.isErr=true;			     
					    		this.ErrorMessage=res.msg
				        	}
					  });
		     	}
		     	else{
		     		this.isErr=true;			     
					this.ErrorMessage='请选择需要删除的策略';
					return false;
		     	}
			  
		    
		
		    	
		    },
		  
		 },
		 mounted() {
			this.pdata.index_id=	 this.$route.params.index_id;
		    this.getList();
		    this.getConfig();
		 }
		 
	}
</script>

<style>
	.md-table-cell-container table{
		padding: 0;
	}
	.md-button{

		min-width: 66px;
	}
	.md-table-cell-container,.md-table-head-label{
		padding: 6px 15px;
	}
</style>


// WEBPACK FOOTER //
// ALDlistDetail.vue?a7b34c72